import * as React from 'react';
import { ListItem, ToolbarConfig } from '@tencent/workbench';
import {
    DropdownType,
    horizontalCenter,
    horizontalLeft,
    horizontalRight,

} from '@editor/src/js/constants/toolbar-data';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import {
    INDENT_INCREASE_ICON,
    INDENT_REDUCE_ICON,
    TOOLBAR_DROPDOWN,
} from '@editor/src/img/pageIndex/index';
import {
    AlignType,
    IndentType,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/text-editor/editor-controller/editor-operations/constant';


export const increaseIndent = {
    id: IndentType.INDENT_INCREASE,
    icon: INDENT_INCREASE_ICON,
    tipMsg: i18n.t<string>('增加缩进'),
    tipPlacement: 'right',
    value: IndentType.INDENT_INCREASE,
};

export const reduceIndent = {
    id: IndentType.INDENT_REDUCE,
    icon: INDENT_REDUCE_ICON,
    tipMsg: i18n.t<string>('减少缩进'),
    tipPlacement: 'right',
    value: IndentType.INDENT_REDUCE,
};

export const config = {
    id: ActionType.INDENT,
    tipMsg: i18n.t('缩进'),
    icon: INDENT_INCREASE_ICON,
    dropdown: {
        icon: TOOLBAR_DROPDOWN,
        type: DropdownType.GRID,
        columns: 1,
        data: [
            increaseIndent,
            reduceIndent,
        ],
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''}/>,
        hasArrow: true,
    },
    {
        name: increaseIndent.id,
        tooltip: increaseIndent.tipMsg,
        icon: <img src={increaseIndent.icon} alt={''}/>,
    },
    {
        name: reduceIndent.id,
        tooltip: reduceIndent.tipMsg,
        icon: <img src={reduceIndent.icon} alt={''}/>,
    },
];

export const MENU_CONFIGS: ListItem[] = [
    {
        id: increaseIndent.id,
        content: '',
        tooltips: increaseIndent.tipMsg,
        icon: <img src={increaseIndent.icon} alt={''} style={{
            width: 24,
            height: 24,
        }} />,
        style: {
            height: 14,
        },
    },
    {
        id: reduceIndent.id,
        content: '',
        tooltips: reduceIndent.tipMsg,
        icon: <img src={reduceIndent.icon} alt={''} style={{
            width: 24,
            height: 24,
        }} />,
        style: {
            height: 14,
        },
    },
];

